import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_LEADERBOARD_SETTINGS: 'leaderboard/ASSIGN_LEADERBOARD_SETTINGS',
    POPULATE_LEADERBOARD_DATA: 'leaderboard/POPULATE_LEADERBOARD_DATA',
    TOGGLE_OVERRIDE_DISPLAY_LIMIT: 'leaderboard/TOGGLE_OVERRIDE_DISPLAY_LIMIT',
    SORT_LEADERBOARD: 'leaderboard/SORT_LEADERBOARD',
    POPULATE_LEADERBOARDAMBASSADOR_DATA: 'leaderboard/POPULATE_AMBASSADOR_DATA',
}

export const actions = {
    assignLeaderboardSettings: createAction<LeaderboardSettingsDto>(types.ASSIGN_LEADERBOARD_SETTINGS),
    populateLeaderboardData: createAction<ApiLeaderboardDataRecord[]>(types.POPULATE_LEADERBOARD_DATA),
    toggleOverrideDisplayLimit: createAction(types.TOGGLE_OVERRIDE_DISPLAY_LIMIT),
    sortLeaderboard: createAction<LeaderboardSort>(types.SORT_LEADERBOARD),
    populateAmbassadorData: createAction<InitiativeDataRecord[]>(types.POPULATE_LEADERBOARDAMBASSADOR_DATA)
}
